import { ModalLayout } from "#layouts";
import React from "react";
import { ClipLoader } from "react-spinners";

export default function CustomModal({
  children,
  onSubmit,
  open,
  onClose,
  loading,
  title,
  actionButtonTitle,
  isCancelButtonRequired,
  isActionButtonRequired = true,
  customClass,
  bodyClass,
  isGenerateButtonRequired,
  GenerateButtonClass,
  GenerateButtonTitle,
  GenerateButtonAction,
  saveBtnClass,
}) {
  return (
    <ModalLayout
      open={open}
      onClose={onClose}
      customClass={customClass}
      bodyClass={bodyClass}
    >
      <div className="common-box-body">
        <h2>{title}</h2>
        {children}
        <div className="common-modal-btns">
          {isCancelButtonRequired && (
            <button class="secondary-btn" onClick={onClose}>
              Cancel
            </button>
          )}

          {isActionButtonRequired && (
            <button
              className={`${saveBtnClass ? saveBtnClass : "btn primary-btn"}`}
              type="button"
              disabled={loading}
              onClick={() => onSubmit()}
            >
              {loading ? (
                <ClipLoader size={17} color="#fff" />
              ) : (
                actionButtonTitle
              )}
            </button>
          )}
          {isGenerateButtonRequired && (
            <button
              class={GenerateButtonClass}
              type="button"
              onClick={() => GenerateButtonAction()}
            >
              {GenerateButtonTitle}
            </button>
          )}
        </div>
      </div>
    </ModalLayout>
  );
}
